import { environment } from "src/environments/environment";

//export var url="http://localhost/web/biofruit/";

//export var url="https://mispracticasangular.000webhostapp.com/php/"

export var url = "https://mbc.qualitapp.com/ws/";
export var urlUpload = "https://mbc.qualitapp.com/ws/upload/";
export var urlUploadAmazon = "https://mbc-qualitapp.s3.eu-west-3.amazonaws.com/";

export var valorAnd =" "; 
export var valorOr =","; 